import type { ElementType, ReactNode } from 'react';
import { styleVars } from '../lib/style.ts';

export interface StackProps {
  children: ReactNode;
  /** Any spacing token or length. Defaults to --space-stack (16px). */
  gap?: string;
  as?: ElementType;
  className?: string;
}

/**
 * Vertical rhythm. Siblings are spaced by gap, never by their own margins — a child
 * that sets its own outer margin is a layer-3 violation.
 */
export function Stack({ children, gap, as: Tag = 'div', className }: StackProps) {
  return (
    <Tag
      className={['stack', className].filter(Boolean).join(' ')}
      style={styleVars({ '--gap': gap })}
    >
      {children}
    </Tag>
  );
}
